import { app } from '../../../../../../app';
import { Controller } from './deactivate-agent.controller';

app.component('companyDirectoryIntegrationManageConnectionDeactivateAgent', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./deactivate-agent.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/deactivate-agent/deactivate-agent.component.js